var _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkill6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 513.81934,
    height: 644.97162,
    viewBox: "0 0 313.81934 644.97162",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "147.753 586.078 135.493 586.077 129.66 538.789 147.755 538.79 147.753 586.078",
    fill: "#ffb6b6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M493.96951,725.47582l-39.53076-.00146v-.5a15.3873,15.3873,0,0,1,15.38647-15.38623h.001l24.144.001Z",
    transform: "translate(-343.09033 -127.51419)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.162 578.548 250.187 581.177 234.349 536.24 252.023 532.36 262.162 578.548",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M610.85474,716.99943l-38.6113,8.47639-.10723-.48836a15.38732,15.38732,0,0,1,11.72872-18.328l.00095-.00021,23.58248-5.177Z",
    transform: "translate(-343.09033 -127.51419)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M456.43436,547.47725l-60.55575,13.06184c-11.614-21.89446-14.22377-44.76462-14.32048-66.39235l60.55543-13.0618A135.60092,135.60092,0,0,0,456.43436,547.47725Z",
    transform: "translate(-343.09033 -127.51419)",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M594.50133,493.81605a11.62615,11.62615,0,0,0-4.982-17.117L590.068,450.137l-16.06037-4.27033-.248,37.52166a11.68915,11.68915,0,0,0,20.74163,10.42776Z",
    transform: "translate(-343.09033 -127.51419)",
    fill: "#ffb6b6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M468.39226,451.99393s-5.9104,2.36413,0,92.2019l2.36414,146.57733h23.64148l26.60977-199.19855,32.494,92.81177,29.55188,109.933L606.695,688.409s-24.82361-222.23023-46.101-236.4151S468.39226,451.99393,468.39226,451.99393Z",
    transform: "translate(-343.09033 -127.51419)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.77673,
    cy: 117.94477,
    r: 24.56942,
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M539.31676,285.32126s-21.27734-10.63867-41.37262-3.54624-30.734,15.367-30.734,15.367l13.00281,68.56036-17.73108,92.20188s91.01984-7.09247,99.29431,0,8.27454-8.27454,8.27454-8.27454l-7.09247-87.47357,13.00287-55.55753Z",
    transform: "translate(-343.09033 -127.51419)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M494.95892,243.76409,500.16,257.05253c2.13134,5.44539,4.57243,11.27134,9.56836,14.31034,6.16828,3.75216,14.40559,1.92259,20.37269-2.142a31.81312,31.81312,0,0,0-14.31932-57.90282l-.24691,4.44763-5.45772-4.57469a5.306,5.306,0,0,1-8.24787,1.16642c1.43367,2.97177-.221,6.59623-2.61041,8.87276-2.93577,2.79666-11.332,6.15776-10.98353,11.15707C488.46775,235.72354,493.60571,240.30664,494.95892,243.76409Z",
    transform: "translate(-343.09033 -127.51419)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M449.51256,495.38894a11.62611,11.62611,0,0,0,.02419-17.82728l7.98411-25.33966-14.21547-8.60766L432.53288,479.5572a11.68915,11.68915,0,0,0,16.97968,15.83174Z",
    transform: "translate(-343.09033 -127.51419)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M475.48467,297.142h-8.27454s-13.00283,8.27453-13.00283,20.09527-18.91318,150.12363-18.91318,150.12363l20.09527,3.54621,17.73114-96.93021,13.00287-26.00568Z",
    transform: "translate(-343.09033 -127.51419)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M553.5017,306.59863h22.45941s7.09247,7.09244,10.63867,23.64151,7.09247,81.5632,7.09247,81.5632l-2.36413,59.1038H573.597l-2.36413-76.8349L559.4121,344.42508Z",
    transform: "translate(-343.09033 -127.51419)",
    fill: "#6c63ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill6);
export default __webpack_public_path__ + "static/media/skill6.b62125d58b33c70592c3327b24ce2c68.svg";
export { ForwardRef as ReactComponent };